import {
  CreateCommentDto,
  CreateEcgDraftDto,
  GetEcgPdfByTokenDto,
  GetLastEcgPdfDto,
  IRequestConfig,
  IRequestOptions,
  PostHealthCheckEcgDto,
  SendEcgByMailDto,
  ShApiResponse_Boolean,
  ShApiResponse_EcgCollectionData,
  ShApiResponse_GetEcgApproveDto,
  ShApiResponse_GetEcgDataValidationDto,
  ShApiResponse_GetEcgPdfDto,
  ShApiResponse_GetEcgPermissionsDto,
  ShApiResponse_GetInterpretationDto,
  ShApiResponse_IEnumerable_GetActionDto,
  ShApiResponse_IEnumerable_GetCommentDto,
  ShApiResponse_IEnumerable_GetFindingDto,
  ShApiResponse_IEnumerable_Symptom,
  ShApiResponse_Int32,
  ShApiResponse_UpdateCommentResponse,
  ShApiResponse_UpdateDraftResponse,
  ShApiResponse_UpdateSaveResponse,
  axios,
  basePath,
  getConfigs,
} from "./index.defs";

export class EcgsApiService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   * Gets the allowed actions for the given ecg
   */
  static ecgsGetEcgAllowedActions(
    params: {
      /**  */
      ecgId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_IEnumerable_GetActionDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/{ecgId}/actions/allowed";
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get Ecg symptoms
   */
  static ecgsGetEcgSymptomsList(
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_IEnumerable_Symptom> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/symptoms";

      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Gets the data of a given ecg
   */
  static ecgsGetEcgData(
    params: {
      /** The unique identifier of the ECG */
      ecgId: string;
      /** The unique id of the ECG to compare to */
      compareTo?: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_EcgCollectionData> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/{ecgId}";
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );
      configs.params = { compareTo: params["compareTo"] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Saves the given ecg
   */
  static ecgsSaveEcg(
    params: {
      /** The unique identifier of the ECG */
      ecgId: string;
      /** ECG data to save */
      draftData: CreateEcgDraftDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_UpdateSaveResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/{ecgId}";
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["draftData"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Request an external review on the given ECG
   */
  static ecgsRequestEcrOnDemand(
    params: {
      /** The unique identifier of the ECG */
      ecgId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/{ecgId}/ecr/on-demand";
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Approve the given ecg
   */
  static ecgsApproveEcg(
    params: {
      /** The unique identifier of the ECG */
      ecgId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetEcgApproveDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/{ecgId}/approve";
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * get the given ecg notes
   */
  static ecgsGetEcgNotes(
    params: {
      /** The unique identifier of the ECG */
      ecgId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_IEnumerable_GetCommentDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/{ecgId}/notes";
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Saves the given ecg ntoes
   */
  static ecgsSaveEcgNotes(
    params: {
      /** The unique identifier of the ECG */
      ecgId: string;
      /** ECG comment to save */
      comment: CreateCommentDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_UpdateCommentResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/{ecgId}/notes";
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["comment"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static ecgsSendEcgToEmails(
    params: {
      /**  */
      ecgId: string;
      /**  */
      ecgByMailDto: SendEcgByMailDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/{ecgId}/share";
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["ecgByMailDto"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Returns the given ecg PDF
   */
  static ecgsGetEcgPdfByToken(
    params: {
      /**  */
      ecgDto: GetEcgPdfByTokenDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetEcgPdfDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/pdf-token";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["ecgDto"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Returns the given ecg PDF
   */
  static ecgsGetEcgPdf(
    params: {
      /** The unique identifier of the ECG */
      ecgId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetEcgPdfDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/{ecgId}/pdf";
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Returns the last ecg PDF for the given parameters
   */
  static ecgsGetLastEcgPdf(
    params: {
      /** The data required to bring the last ECG */
      ecgData: GetLastEcgPdfDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetEcgPdfDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/pdf";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["ecgData"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Saves the given ecg draft
   */
  static ecgsSaveEcgDraft(
    params: {
      /** The unique identifier of the ECG */
      ecgId: string;
      /** ECG data to be saved */
      draftData: CreateEcgDraftDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_UpdateDraftResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/{ecgId}/draft";
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["draftData"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get ecg permissions for the given ecg
   */
  static ecgsGetEcgPermissions(
    params: {
      /** The unique identifier of the ECG */
      ecgId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetEcgPermissionsDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/{ecgId}/permissions";
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get comments for the given ecg
   */
  static ecgsGetEcgComments(
    params: {
      /** The unique identifier of the ECG */
      ecgId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_IEnumerable_GetCommentDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/{ecgId}/comments";
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get the last interpretation for the given ecg
   */
  static ecgsGetEcgInterpretation(
    params: {
      /** The unique identifier of the ECG */
      ecgId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetInterpretationDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/{ecgId}/interpretations";
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get findings for the given ecg
   */
  static ecgsGetEcgFindings(
    params: {
      /** The unique identifier of the ECG */
      ecgId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_IEnumerable_GetFindingDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/{ecgId}/findings";
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get actions for the given ecg
   */
  static ecgsGetEcgActions(
    params: {
      /** The unique identifier of the ECG */
      ecgId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_IEnumerable_GetActionDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/{ecgId}/actions";
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * End all review sessions of the given ECG (of the authenticated user)
   */
  static ecgsEndReviewSession(
    params: {
      /** The unique identifier of the ECG */
      ecgId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/{ecgId}/review-sessions";
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "delete",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Request to extend the given ECG's review session
   */
  static ecgsExtendReviewSession(
    params: {
      /** The unique identifier of the ECG */
      ecgId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Int32> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/{ecgId}/review-sessions";
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "patch",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Moves the given ECG to the archive. An archived ECG cannot be de-archived.
   */
  static ecgsArchiveEcg(
    params: {
      /** The unique identifier of the ECG */
      ecgId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/{ecgId}/archives";
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static ecgsPostHealthCheck(
    params: {
      /**  */
      postHealthCheckEcgDto: PostHealthCheckEcgDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/health-check";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["postHealthCheckEcgDto"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Gets the basic data of a given ecg with instructions.
   */
  static ecgsGetEcgDataValidation(
    params: {
      /** The unique identifier of the ECG */
      ecgId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetEcgDataValidationDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/{ecgId}/data-validation";
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Update action accepted on the given ECG
   */
  static ecgsSetEcgActionConfirmation(
    params: {
      /** The unique identifier of the ECG */
      ecgId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/ecgs/{ecgId}/actions/confirmation";
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
